
// ==== CONFIG =====
const priceText = document.getElementById("main-price")?.textContent || "0";
const BASE_PRICE =0;// parseFloat(priceText.replace('$', '').trim());
let currentPrice = BASE_PRICE;
const priceElement = document.getElementById("main-price");

// // Dummy options object — Replace this with: `{{ product.metafields.bcpo.bcpo_data }}`
// const options = {
//   virtual_options: [] // Fill this with actual Shopify metafield options
// };

// ==== HELPERS =====
const getVariantBySKU = async (sku) => {
  
  const res = await fetch(`https://productconfigurator.ahw2m.net/get_product_by_sku?sku=${sku}`);
  const json = await res.json();
  return json || null;
};

function updatePriceDisplay() { if (currentPrice <= 0) { var _bcpoDP = priceElement.parentElement, _bcpoDSale = null; while (_bcpoDP && !_bcpoDSale) { _bcpoDSale = _bcpoDP.querySelector(".price-item--sale"); _bcpoDP = _bcpoDP.parentElement; } if (_bcpoDSale && _bcpoDSale.textContent.trim()) { priceElement.textContent = _bcpoDSale.textContent.trim(); } return; }

converted = currentPrice.toFixed(2);

const formatted = new Intl.NumberFormat(undefined, {
  style: 'currency',
  currency: Shopify.currency.active
}).format(converted);


  priceElement.textContent = `${formatted}`;
}

// ==== MAIN RENDER FUNCTION =====
function renderOptions() {
  const loader = document.getElementById("virtual-options-loader");
  const container = document.getElementById("virtual-options-container");
  if (!loader || !container) return;

  loader.style.display = "flex";

  options.virtual_options.forEach((group, groupIndex) => {
    const fieldset = document.createElement("fieldset");
    const legend = document.createElement("legend");
    legend.innerText = `${group.title}:`;
    fieldset.appendChild(legend);

    const isFirstGroup = groupIndex === 0;

    if (group.type === "default") {
      const select = document.createElement("select");
      select.style.padding = "10px";
      select.name = `add-on[${group.title}]`;

      const defaultOption = document.createElement("option");
      defaultOption.value = "";
      defaultOption.textContent = "-- Select --";
      select.appendChild(defaultOption);

      group.values.forEach((val, index) => {
        const option = document.createElement("option");
        option.value = val.sku;
        option.dataset.price = parseFloat((val.price * Shopify.currency.rate).toFixed(2));
        option.dataset.variantId = parseFloat(val.variantid);
        let statusText = val.status || '';
        let statusClass = "stock-none";
        if (statusText.toLowerCase() === "in stock") statusClass = "stock-green";
        else if (statusText.toLowerCase() === "out of stock") statusClass = "stock-red";

        if (statusText.toLowerCase() === "out of stock") {
          option.disabled = true;
          option.style.color = "gray";
        }

        const dashstatusText = statusText ? '-' : '';
const basePrice = val.price; // if price is in cents

   converted = basePrice * Shopify.currency.rate;

const formatted = new Intl.NumberFormat(undefined, {
  style: 'currency',
  currency: Shopify.currency.active
}).format(converted);


        option.innerHTML = `${val.title} – ${formatted} ${dashstatusText} ${statusText}`;

        select.appendChild(option);
if (parseFloat(val.defaultselect) === 1) {
  option.selected = true;
  currentPrice += parseFloat((val.price * Shopify.currency.rate).toFixed(2));
}
      });

      select.addEventListener("change", () => {
        currentPrice = BASE_PRICE;
        document.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').forEach(el => {
          currentPrice += parseFloat(el.dataset.price || 0);
        });
        document.querySelectorAll("select").forEach(sel => {
          const selected = sel.selectedOptions[0];
          currentPrice += parseFloat(selected?.dataset?.price || 0);
        });
        updatePriceDisplay();
      });

      fieldset.appendChild(select);
    } else {
      const inputType = group.type === "radios" ? "radio" : "checkbox";

      group.values.forEach((val, index) => {
        const id = `${group.unique}_${index}`;
        const wrapper = document.createElement("div");
        wrapper.style.margin = "10px 0";

        const input = document.createElement("input");
        input.type = inputType;
        input.id = id;
        input.name = inputType === "radio" ? `add-on[${group.title}]` : `add-on[${group.title}][]`;
        input.value = val.sku;
        input.dataset.price = parseFloat((val.price * Shopify.currency.rate).toFixed(2));
        input.dataset.variantId = parseFloat(val.variantid);
       if (parseFloat(val.defaultselect) === 1) {
  input.checked = true;
  if (inputType === "radio") {
    currentPrice += parseFloat((val.price * Shopify.currency.rate).toFixed(2));
  } else {
    currentPrice += parseFloat((val.price * Shopify.currency.rate).toFixed(2));
  }
}

        input.addEventListener("change", () => {
          if (inputType === "radio") {
            currentPrice = BASE_PRICE;
            document.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').forEach(el => {
              currentPrice += parseFloat(el.dataset.price || 0);
            });
            document.querySelectorAll("select").forEach(sel => {
              const selected = sel.selectedOptions[0];
              currentPrice += parseFloat(selected?.dataset?.price || 0);
            });
          } else {
            const change = parseFloat(input.dataset.price);
            currentPrice += input.checked ? change : -change;
          }
          updatePriceDisplay();
        });

        const label = document.createElement("label");
        label.setAttribute("for", id);

        let statusText = val.status || '';
        let statusClass = "stock-none";
        if (statusText.toLowerCase() === "in stock") statusClass = "stock-green";
        else if (statusText.toLowerCase() === "out of stock") statusClass = "stock-red";
        else if (statusText.toLowerCase() === "back order") statusClass = "stock-backorder";
        const dashstatusText = statusText ? '-' : '';

        if (statusText.toLowerCase() === "out of stock") {
          input.disabled = true;
          label.style.color = "gray";
        }
        console.log("price");
console.log(Shopify.currency.rate);
console.log(val.price);
const basePrice = val.price; // if price is in cents

  converted = basePrice * Shopify.currency.rate;


  

const formatted = new Intl.NumberFormat(undefined, {
  style: 'currency',
  currency: Shopify.currency.active
}).format(converted);

label.innerHTML = `${val.title} – ${formatted} ${dashstatusText} <span class="${statusClass}">${statusText}</span>`;


      //  label.innerHTML = `${val.title} – $${parseFloat((val.price * Shopify.currency.rate).toFixed(2))} ${dashstatusText} <span class="${statusClass}">${statusText}</span>`;

        wrapper.appendChild(input);
        wrapper.appendChild(label);
        fieldset.appendChild(wrapper);
      });
    }

    container.appendChild(fieldset);
  });

  loader.style.display = "none";
  if (currentPrice > 0) updatePriceDisplay();
}

// ==== INIT ON DOM LOAD ====
document.addEventListener("DOMContentLoaded", function () {

  if(!options){
    return;
  }
  const productForm = document.querySelector("product-form.product-form");
  const buttonsSection = productForm?.querySelector(".product-form__buttons");
  if (!productForm || !buttonsSection) {
    console.warn("Product form or buttons section not found.");
    return;
  }

  const wrapper = document.createElement("div");
  wrapper.className = "w2moptionvo";

  const innerWrapper = document.createElement("div");
  innerWrapper.className = "virtual-options-wrapper";
  innerWrapper.style.position = "relative";

  const loader = document.createElement("div");
  loader.id = "virtual-options-loader";
  loader.style.cssText = `
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(255,255,255,0.8);
    z-index: 99;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 16px;
    color: #333;
    display: none;
  `;
  loader.innerText = "Loading options...";

  const container = document.createElement("div");
  container.id = "virtual-options-container";

  innerWrapper.appendChild(loader);
  innerWrapper.appendChild(container);
  wrapper.appendChild(innerWrapper);
  buttonsSection.parentNode.insertBefore(wrapper, buttonsSection);

  const style = document.createElement("style");
  style.textContent = `
    #virtual-options-container fieldset {
      border: none !important;
      margin-bottom: 16px;
    }
    .stock-green { color: green; }
    .stock-red { color: red; }
    .stock-none { color: gray; }
    .stock-backorder{ color: #f200ff; }
  `;
  document.head.appendChild(style);

  // 🔁 Load product options
  renderOptions();
});





document.addEventListener('DOMContentLoaded', () => {
 
   var virtualoptionscontainer = document.querySelector('#virtual-options-container');
     if (!virtualoptionscontainer) 
    {
return ;
    }


  const addToCartBtn = document.querySelector('.product-form__submit');

  if (!addToCartBtn) {
    console.warn('Add to Cart button not found');
    return;
  }


  

  addToCartBtn.addEventListener('click', async (e) => {

    
   var virtualoptionscontainer = document.querySelector('#virtual-options-container');
     if (!virtualoptionscontainer) 
    {
return ;
    }


    e.preventDefault();

    const quantityInput = document.querySelector('.quantity__input');
    const quantity = parseInt(quantityInput?.value || "1");

    const mainForm = document.querySelector('form[action^="/cart/add"]');
    const formData = new FormData(mainForm);
    const mainVariantId = parseInt(formData.get('id'), 10);

    const items = [];
    let checknone=0;

  // ✅ Add main product
    // if (mainVariantId) {
    //   items.push({
    //     id: mainVariantId,
    //     quantity: quantity
    //     // properties: {
    //     //   Type: 'Main Product'
    //     // }
    //   });
    // }
    // ✅ Checkboxes (multi select)
    document.querySelectorAll('input[type="checkbox"]:checked').forEach(input => {

      
      const variantId = parseInt(input.dataset.variantId, 10);
if(input.value =="none"){
  checknone=1;
}


      
      if (variantId && input.value !="none") {
      
  //  const product__title_text = $('.product__title').text().replace(/\s+/g, ' ').trim();
  //        alert(product__title_text);
        items.push({
          id: variantId,
          quantity: quantity
      //      properties: {
      //  //   Main_Product:product__title_text         
      //     }
        });
      }
    });

    // ✅ Radios (single select)
    document.querySelectorAll('input[type="radio"]:checked').forEach(input => {

    if(input.value =="none"){
  checknone=1;
}
      const variantId = parseInt(input.dataset.variantId, 10);
      if (variantId && input.value !="none") {
  // const product__title_text = $('.product__title').text().replace(/\s+/g, ' ').trim();
  //     alert(product__title_text);
        items.push({
          id: variantId,
          quantity: quantity
          //  properties: {
          // //Main_Product:product__title_text
          //  }
        });
      }
    });

    // ✅ Dropdowns (select elements)
    document.querySelectorAll('select').forEach(select => {
      const selected = select.selectedOptions[0];
 
if(selected.value =="none"){
  checknone=1;
}
      
      const variantId = parseInt(selected?.dataset.variantId, 10);
      if (variantId && selected.value !="none") {
       
        items.push({
          id: variantId,
          quantity: quantity
          // properties: {
          //   Type: 'Sub Product',
          //   ParentProduct: mainVariantId
          // }
        });
      }
    });
items.reverse();
   
console.log(checknone);
    if ((items.length === 0 && options)) {
    if(checknone==0){
      alert("Please select a product to add to cart.");
      return;
    }
    }
//     console.log(JSON.stringify({ items }));
// return;
    console.log("Sending to cart:", JSON.stringify({ items }));

    // Guard against a rapid double-click firing two overlapping adds —
    // not present before this change.
    addToCartBtn.disabled = true;
    addToCartBtn.setAttribute('aria-disabled', 'true');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      const addData = await res.json();

      // Previously any failed add (e.g. a sold-out variant) silently
      // redirected to /cart anyway, since res.json() doesn't throw on a
      // non-2xx response — Shopify's cart/add.js error shape is
      // { status, message, description }.
      if (!res.ok || addData.status) {
        alert(addData.description || addData.message || "Something went wrong. Please try again.");
        return;
      }

      // /cart/add.js's response for a multi-item POST only returns the
      // newly-added items, not full cart totals/item_count — a follow-up
      // GET gives clean structured data for both the popup and the header
      // badge, on either design, without needing to parse rendered HTML.
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cart });
      }

      if (window.MiniCartPopup) {
        window.MiniCartPopup.updateHeaderBadges(cart.item_count);
        window.MiniCartPopup.open(null, cart);
      }
    } catch (err) {
      console.error("Error adding to cart", err);
      alert("Something went wrong. Please try again.");
    } finally {
      addToCartBtn.disabled = false;
      addToCartBtn.removeAttribute('aria-disabled');
    }
  });
});
